/* Helite size calculator: reads ranges from the matching size chart on the page */
(function () {
  var KEYS = ['height', 'chest', 'waist', 'hips'];
  var NAMES = { height: 'height', chest: 'chest', waist: 'waist', hips: 'hips' };
  var DEF = { height: 175, chest: 100, waist: 92, hips: 100 };
  var NEAR = 10;

  function readChart(title) {
    var want = (title || '').trim().toLowerCase(), panel = null;
    document.querySelectorAll('.srsize__panel').forEach(function (p) {
      var h = p.querySelector('.srsize__title');
      if (!panel && h && h.textContent.trim().toLowerCase() === want) panel = p;
    });
    if (!panel) return null;
    var sizes = [].slice.call(panel.querySelectorAll('thead th')).slice(1).map(function (t) { return t.textContent.trim(); });
    var rows = {};
    panel.querySelectorAll('tbody tr').forEach(function (tr) {
      var k = tr.querySelector('th').textContent.trim().toLowerCase();
      rows[k] = [].slice.call(tr.querySelectorAll('td')).map(function (td) {
        var m = td.textContent.match(/(\d+)\s*-\s*(\d+)/);
        return m ? [+m[1], +m[2]] : null;
      });
    });
    if (!KEYS.every(function (k) { return rows[k] && rows[k].length === sizes.length; })) return null;
    return { sizes: sizes, rows: rows };
  }

  function pick(chart, v) {
    var best = null;
    chart.sizes.forEach(function (name, i) {
      var r = { name: name, total: 0, count: 0, centre: 0, miss: [] };
      KEYS.forEach(function (k) {
        var lo = chart.rows[k][i][0], hi = chart.rows[k][i][1], d = 0;
        if (v[k] < lo) d = v[k] - lo; else if (v[k] > hi) d = v[k] - hi;
        if (d) { r.total += Math.abs(d); r.count++; r.miss.push({ k: k, d: d }); }
        r.centre += Math.abs(v[k] - (lo + hi) / 2) / Math.max(1, hi - lo);
      });
      if (!best || r.total < best.total || (r.total === best.total && (r.count < best.count || (r.count === best.count && r.centre < best.centre)))) best = r;
    });
    return best;
  }

  function label(name) {
    var m = name.match(/^(X?L)-Wide$/i);
    return m ? 'Labelled ' + m[1].toUpperCase() + '-L on the vest.' : '';
  }

  function init(root) {
    var chart = readChart(root.getAttribute('data-chart'));
    if (!chart) return;
    var state = {}, fields = {};
    var prompt = root.querySelector('.szc__prompt'), answer = root.querySelector('.szc__answer');
    var sizeEl = root.querySelector('.szc__size'), metaEl = root.querySelector('.szc__meta');
    var noteEl = root.querySelector('.szc__note'), actions = root.querySelector('.szc__actions');
    var kEl = root.querySelector('.szc__k');
    var email = root.getAttribute('data-email'), shop = root.getAttribute('data-shop'), shopLabel = root.getAttribute('data-shop-label');
    var lastSize = '';

    KEYS.forEach(function (k) {
      var f = root.querySelector('[data-key="' + k + '"]'), range = f.querySelector('.szc__range'), num = f.querySelector('.szc__num'), bub = f.querySelector('.szc__bubble');
      var lo = Math.min.apply(null, chart.rows[k].map(function (r) { return r[0]; }));
      var hi = Math.max.apply(null, chart.rows[k].map(function (r) { return r[1]; }));
      var min = Math.floor((lo - 15) / 5) * 5, max = Math.ceil((hi + 20) / 5) * 5;
      range.min = num.min = min; range.max = num.max = max;
      range.value = Math.min(max, Math.max(min, DEF[k]));
      fields[k] = { f: f, range: range, num: num, bub: bub, min: min, max: max };
      paint(k);
      function set(val, fromNum) {
        val = Math.round(+val);
        if (isNaN(val)) return;
        var c = Math.min(max, Math.max(min, val));
        range.value = c;
        if (!fromNum || c === val) num.value = c;
        state[k] = c;
        f.classList.remove('is-unset');
        paint(k); update();
      }
      range.addEventListener('input', function () { set(range.value); });
      num.addEventListener('input', function () { var n = +num.value; if (n >= min && n <= max) set(n, true); });
      num.addEventListener('change', function () { set(num.value); });
      ['pointerdown', 'focus'].forEach(function (e) { range.addEventListener(e, function () { f.classList.add('is-active'); }); });
      ['pointerup', 'blur'].forEach(function (e) { range.addEventListener(e, function () { f.classList.remove('is-active'); }); });
    });

    function paint(k) {
      var x = fields[k], p = (x.range.value - x.min) / (x.max - x.min) * 100;
      x.range.style.setProperty('--p', p + '%');
      x.bub.style.setProperty('--p', p);
      x.bub.textContent = x.range.value;
      x.range.setAttribute('aria-valuetext', x.range.value + ' centimetres');
    }

    function mailto(v, size) {
      var body = 'Hi, could you check my size for the Turtle 2 / e-Turtle?\n\n' +
        KEYS.map(function (k) { return k.charAt(0).toUpperCase() + k.slice(1) + ': ' + v[k] + ' cm'; }).join('\n') +
        '\n(measured over a t-shirt)\n\nThe calculator suggested: ' + size;
      return 'mailto:' + email + '?subject=' + encodeURIComponent('Size check: Turtle 2 / e-Turtle') + '&body=' + encodeURIComponent(body);
    }

    function btn(href, text, cls) {
      var a = document.createElement('a');
      a.href = href; a.textContent = text; a.className = cls;
      return a;
    }

    function update() {
      var left = KEYS.filter(function (k) { return state[k] == null; }).length;
      if (left) {
        prompt.hidden = false; answer.hidden = true;
        prompt.textContent = left === 4 ? 'Move each slider to your measurement to see your size.' : left + ' more to go.';
        return;
      }
      var r = pick(chart, state);
      prompt.hidden = true; answer.hidden = false;
      actions.textContent = '';
      var out = r.total > NEAR;
      sizeEl.textContent = out ? 'Talk to us' : r.name;
      sizeEl.classList.toggle('is-out', out);
      metaEl.textContent = out ? '' : label(r.name);
      metaEl.hidden = !metaEl.textContent;
      kEl.hidden = out;
      if (out) {
        noteEl.textContent = 'Your measurements sit outside the Turtle 2 and e-Turtle range. Send them through and we will help you find the right fit.';
        actions.appendChild(btn(mailto(state, 'no size in range'), 'Send us your measurements', 'szc__btn szc__btn--pill'));
      } else if (r.total === 0) {
        noteEl.textContent = 'All four measurements sit inside the ' + r.name.replace('-', '‑') + ' range.';
        if (shop) actions.appendChild(btn(shop, shopLabel || 'Shop vests', 'szc__btn'));
        actions.appendChild(btn(mailto(state, r.name), 'Still unsure? Ask us', 'szc__link'));
      } else {
        var parts = r.miss.map(function (m) { return 'your ' + NAMES[m.k] + ' is ' + Math.abs(m.d) + ' cm ' + (m.d > 0 ? 'over' : 'under'); });
        var txt = parts.length > 1 ? parts.slice(0, -1).join(', ') + ' and ' + parts[parts.length - 1] : parts[0];
        noteEl.textContent = txt.charAt(0).toUpperCase() + txt.slice(1) + ' the ' + r.name.replace('-', '‑') + ' range. It\'s still your closest size, and we can double-check it for you.';
        actions.appendChild(btn(mailto(state, r.name), 'Check my size with us', 'szc__btn szc__btn--pill'));
        if (shop) actions.appendChild(btn(shop, shopLabel || 'Shop vests', 'szc__link'));
      }
      if (sizeEl.textContent !== lastSize) {
        sizeEl.classList.remove('is-in'); void sizeEl.offsetWidth; sizeEl.classList.add('is-in');
        lastSize = sizeEl.textContent;
      }
    }

    root.hidden = false;
    update();
  }

  function boot() { document.querySelectorAll('[data-szc]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.HeliteSizeCalc = { pick: pick };
})();
